import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/react";
import {ChevronDownIcon} from "@heroicons/react/20/solid";
import {logInWithBusiness} from "../../utils/OrgManagement.ts";
import {User} from "../../api/accessControl/User.ts";

function getBusinessInitials(name: string): string {
    return name
        .split(' ')
        .slice(0, 2)
        .map((word) => word.charAt(0))
        .join('');
}

export function BusinessSwitch(props: {
    currentUser: User;
    className?: string;
}) {
    const currentBusinessName = props.currentUser.getBusinessName() || 'Business';
    const canSwitch = props.currentUser.access && props.currentUser.access.length > 1;

    return (
        <Menu as="div" className={`relative inline-flex ${props.className ?? ''}`}>
            <MenuButton
                disabled={!canSwitch}
                className={`flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm transition hover:bg-gray-50 focus:outline-none ${canSwitch ? '' : 'cursor-default opacity-70'}`}
            >
                <span className="rounded-sm bg-superliteprimary p-1 text-center text-xs text-primary w-[4ch]">
                    {getBusinessInitials(currentBusinessName)}
                </span>
                <span className="max-w-[22ch] truncate">{currentBusinessName}</span>
                {canSwitch && <ChevronDownIcon className="h-4 w-4 text-gray-400" />}
            </MenuButton>

            {canSwitch && (
                <MenuItems
                    transition
                    className="absolute left-0 z-40 mt-2 w-64 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-2">
                        {props.currentUser.access.map((biz) => {
                            const isActive = biz.business_name === currentBusinessName;

                            return (
                                <MenuItem key={biz.business_id} as="div" className="px-2">
                                    <button
                                        onClick={() => logInWithBusiness(biz.business_id)}
                                        className={`flex w-full items-center gap-2 rounded-md px-2 py-2 text-sm transition hover:bg-gray-100 ${isActive ? 'text-primary font-semibold' : 'text-gray-600'}`}
                                    >
                                        <span
                                            className={`w-[4ch] rounded-sm p-1 text-center text-xs ${isActive ? 'bg-superliteprimary text-primary' : 'bg-gray-100 text-gray-500'}`}
                                        >
                                            {getBusinessInitials(biz.business_name)}
                                        </span>
                                        <span className="truncate">{biz.business_name}</span>
                                    </button>
                                </MenuItem>
                            );
                        })}
                    </div>
                </MenuItems>
            )}
        </Menu>
    );
}
